import React from 'react'
import moment from 'moment'
import generateDifferenceLabel from './duration-difference-label'

const defaultUnits = [
    'second',
    'minute',
    'hour',
    'day',
    'week',
    'month',
    'year',
]

const RelativeDate = ({
    value,
    units = defaultUnits,
    invalidLabel
}) => {
    const date = moment(value)

    if (!date.isValid()) {
        return (<React.Fragment>{invalidLabel}</React.Fragment>)
    }
    const today = moment()
    let content = date.format('MM/DD/YYYY LTS')
    units.forEach( unit => content = generateDifferenceLabel(today, date, unit, content))

    return (
        <React.Fragment>{content}</React.Fragment>
    )
}

export default RelativeDate
